<script>
import LazyImage from "@/components/atoms/lazy-image";
import Container from "@/components/atoms/container";
import Button from "@/components/atoms/button";
import pageErreur from "@/assets/images/404-maintenance/page-erreur.gif";

import { pageMaintenanceProps, usePageMaintenance } from "./mixin";

export default {
  name: "PageErreur",
  components: {
    LazyImage,
    Container,
    Button
  },
  props: {
    ...pageMaintenanceProps()
  },
  setup() {
    const { reload } = usePageMaintenance();
    return { pageErreur, reload };
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <Container>
      <div class="u-mt-sm u-mb-xlg">
        <div class="u-flex u-flex-column u-flex-align-center u-mb-lg">
          <LazyImage
            :src="pageErreur"
            alt=""
            width="240"
            class="u-mb-md"
          />
          <div class="u-text-center">
            <p class="u-font-27 u-font-secondary u-color-primary u-font-700 u-mb-sm">
              On dirait qu’il y a un pépin...
            </p>
            <p class="u-font-18 u-color-grey-1">
              <template v-if="isTemp">
                Une erreur temporaire est survenue. Veuillez réessayer.
              </template>
              <template v-else>
                Une erreur est survenue. Nos équipes techniques mettent tout en œuvre pour rétablir la situation.
              </template>
            </p>
          </div>
        </div>
        <div class="u-flex u-flex-column u-flex-align-center">
          <Button
            variant="primary"
            radius="full"
            size="md"
            class="u-mb-sm"
            @click="reload"
          >
            Rafraîchir la page
          </Button>
          <Button
            variant="primary"
            outline
            radius="full"
            size="md"
            :to="borne ? '/prospectus/borne' :'/'"
          >
            Aller à l’accueil
          </Button>
        </div>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
</style>
